import React from 'react';

export const SpeakerHalfFullSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="38"
    height="30"
    viewBox="0 0 30 27"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.3439 24.9663C19.3439 25.624 18.9639 26.2215 18.3692 26.5004C18.1393 26.6091 17.8929 26.6617 17.6481 26.6617C17.2605 26.6617 16.8765 26.5285 16.5663 26.2713L7.2978 18.591H2.36138C1.42522 18.5918 0.666016 17.8322 0.666016 16.896V10.1414C0.666016 9.20485 1.42522 8.44565 2.36138 8.44565H7.2982L16.5667 0.76535C17.0731 0.345621 17.7754 0.256138 18.3696 0.537027C18.9639 0.81591 19.3443 1.4138 19.3443 2.07108L19.3439 24.9663ZM25.8593 22.3171C25.818 22.32 25.7783 22.3216 25.7373 22.3216C25.2895 22.3216 24.8578 22.1446 24.5388 21.8252L24.312 21.5977C23.7174 21.0042 23.6475 20.064 24.1483 19.3891C25.4179 17.6773 26.0881 15.648 26.0881 13.5193C26.0881 11.2297 25.3272 9.08207 23.8875 7.30845C23.3394 6.63432 23.3899 5.65522 24.0043 5.04128L24.2306 4.81456C24.5692 4.47589 25.0231 4.29131 25.5142 4.3206C25.9926 4.34468 26.4392 4.56979 26.7425 4.94056C28.7396 7.38429 29.7946 10.3513 29.7946 13.5197C29.7946 16.4706 28.8616 19.2795 27.096 21.6414C26.8011 22.0351 26.3501 22.2822 25.8593 22.3171Z"
      fill="currentColor"
    />
  </svg>
);

export default SpeakerHalfFullSvg;
